module.exports = __webpack_public_path__ + "static/media/BAJAJFINSV.508b1261.txt";